<div class="component">
  <muni-gameday-panel [title]="'ORDER SUMMARY'" [isActive]="true" [condensed]="true">
    <muni-gameday-order-summary-chart
      [highlightMaturityId]="highlightMaturityId | async"
    >
    </muni-gameday-order-summary-chart>
    <div class="tableWrapper">
      <table>
        <thead data-automation-e2e-selector="orderSummaryCardTableHeaders">
          <tr>
            <th
              [textContent]="'Maturity'"
              data-automation-e2e-selector="maturity"
            ></th>
            <th
              [textContent]="'Amount (M)'"
              data-automation-e2e-selector="amount"
            ></th>
          </tr>
        </thead>
        <tbody data-automation-e2e-selector="orderSummaryCardTable">
          <tr
            *ngFor="let order of (ordersSummary | async); trackBy: trackBy"
            class="order-row"
            (mouseover)="highlightOrder(order.id)"
            (mouseout)="highlightOrder(undefined)"
            data-automation-e2e-selector="orderSummaryTableRow"
            [attr.data-automation-e2e-item-id]="order.id"
          >
            <td
              [textContent]="order.name"
              data-automation-e2e-selector="maturity"
            ></td>
            <td
              [textContent]="order.amountFormatted"
              data-automation-e2e-selector="amount"
            ></td>
          </tr>
        </tbody>
      </table>
    </div>
  </muni-gameday-panel>
</div>
